import { render, staticRenderFns } from "./KanbanTaskLaneCounter.vue?vue&type=template&id=dc23162a"
import script from "./KanbanTaskLaneCounter.vue?vue&type=script&lang=js"
export * from "./KanbanTaskLaneCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports